import { RootContainer } from '../../../../core/root_container';
import { TableTxFilterHeaderModel } from '../../../models/table_tx_filter_header_model';
import { TableTxFilterHeaderContent } from './table_tx_filter_header_content';
import TableTooltipAction, { DATA_HEADER_COLS } from '../../../actions/table_tooltip_action';

export default class TableTxFilterContentContainer extends RootContainer<TableTxFilterHeaderModel> {
  constructor(model: TableTxFilterHeaderModel, id: string) {
    super();
    super.mount(TableTxFilterHeaderContent, id);
    this.update(model);
  }

  static init(model?: TableTxFilterHeaderModel) {
    if (!model) {
      return null;
    }
    let cols = document.querySelector('#variations-table-all-area')?.getAttribute(DATA_HEADER_COLS);
    if (cols) {
      const set = new Set(cols.split(',')); // e.g: "1,3,5" => ["1", "3", "5"]
      // model?.headers.map((item, index) => {... } 使えない理由： ソロアリで導入したkumu.jsというlibの影響でindex使えなくなる
      for (let i = 0; i < (model?.headers?.length || 0); i++) {
        const item = model?.headers[i];
        item.shouldShown = set.has('' + i);
      }
    }
    TableTooltipAction.changeTableTxHeader(model);
    return new TableTxFilterContentContainer(model, model.id);
  }
}
